import { i18n } from "@tellescope/i18n";

export const getTimezoneName = (
  timeZone: string,
  timeZoneName: "short" | "long" | "shortOffset" | "longOffset" | "shortGeneric" | "longGeneric",
  language: string = i18n.language
): string =>
  Intl.DateTimeFormat(language || "en-US", {
    hour: "numeric",
    timeZone,
    timeZoneName,
  })
    .format(new Date())
    .split(/\s/g)
    .slice(2)
    .join(" ");
